'use client';

import logoWordLight from '@/public/images/logos/logo-word-white.png';
import React, { useMemo } from 'react';

import useAppLanguage from '../../../../hooks/useAppLanguage';
import useAuth from '../../../../hooks/useAuth';
import { checkHasBrandingData } from '../../../../utils/utils';

const Logo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ src, ...rest }) => {
  const { translate } = useAppLanguage();
  const { brandingData } = useAuth();

  const hasBrandingData = useMemo(() => {
    return checkHasBrandingData(brandingData);
  }, [brandingData]);

  const logoUrl = useMemo(() => {
    if (hasBrandingData && brandingData?.logo) {
      return brandingData.logo;
    } else {
      return logoWordLight.src;
    }
  }, [brandingData, hasBrandingData]);

  return (
    <img
      className="max-w-full max-h-full object-contain"
      src={logoUrl ?? ''}
      alt={translate('Wonderschool Logo')}
      data-testid="wonderschool-logo-word"
      {...rest}
    />
  );
};
export default Logo;
